import type {Props} from '@/hooks/use-sw-post-message'

export const useSWPostMessage = ({type, message}: Props) => null
